import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Stkmb } from '../entity/Stkmb-angular';


@Injectable({
  providedIn: 'root'
})
export class StkmbServicePkg extends JkEntityV2 {


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Stkmb();
    this.entityType.type = EntityType.data;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      MB001: '帳號代號', MB002: '帳號', MB003: '帳戶名稱', MB004: '銀行代號', MB005: '電話1', MB006: '手機', MB007: '備註', MB008: '現行年度', MB009: '現行月份', MB010: '本年期初損益', MB011: '本年損益', MB012: '本月損益', MB013: '單筆最低手續費', MB014: '手續費', MB015: '折扣手續費', MB020: '通知方式', MB021: '通知參數1', MB022: '參數2', MB023: '參數3', MB024: '參數4', MB025: '通知內容', MB026: '過濾SQL', MB016: '使用者代號', MB017: '身分證號', MB018: '分類'
    };

    this.fieldNames = 'MB001,MB002,MB003,MB004,MB005,MB006,MB007,MB008,MB009,MB010,MB011,MB012,MB013,MB014,MB015,MB020,MB021,MB022,MB023,MB024,MB025,MB026,MB016,MB017,MB018';
    this.fieldLengths = { MB001: 6, MB002: 20, MB003: 10, MB004: 10, MB005: 20, MB006: 20, MB007: 255, MB008: 4, MB009: 2, MB010: 8, MB011: 8, MB012: 8, MB013: 8, MB014: 10.6, MB015: 10.6, MB020: 1, MB021: 20, MB022: 100, MB023: 100, MB024: 100, MB025: 300, MB026: 0, MB016: 10, MB017: 10, MB018: 6 };
    this.columnDefs = [
      { field: "MB024", headerName: "參數4", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "MB015", headerName: "折扣手續費", headerTooltip: "", width: 155, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MB020", headerName: "通知方式", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "MB021", headerName: "通知參數1", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "MB022", headerName: "參數2", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "MB023", headerName: "參數3", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "MB014", headerName: "手續費", headerTooltip: "", width: 155, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MB025", headerName: "通知內容", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "MB026", headerName: "過濾SQL", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "MB016", headerName: "使用者代號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "MB017", headerName: "身分證號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "MB018", headerName: "分類", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "MB001", headerName: "帳號代號", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "MB007", headerName: "備註", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "MB002", headerName: "帳號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "MB003", headerName: "帳戶名稱", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "MB004", headerName: "銀行代號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "MB005", headerName: "電話1", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "MB006", headerName: "手機", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "MB013", headerName: "單筆最低手續費", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MB008", headerName: "現行年度", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "MB009", headerName: "現行月份", headerTooltip: "", width: 86, cellDataType: "text", },
      { field: "MB010", headerName: "本年期初損益", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MB011", headerName: "本年損益", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MB012", headerName: "本月損益", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'STKMB';
    this.isSys = false;
    this.sqlSelect = `SELECT STKMB.*  FROM STKMB`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY MB001`;
    this.keyFields = ['MB001'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['MB001'];
    this.seqField = '';
    this.seqFieldLength = 0;
  }
  override async validateItem(item: Stkmb): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Stkmb): Promise<Stkmb> {
    await super.newRecord(newItem);
    return newItem;
  }




}

